<template>
   <section class="update_container">
       <section class="info_con" v-if="status === 1">
           <span class="text right-5">文件正在上传中</span>
           <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
       </section>
       <section class="info_con icon-sucess" v-if="status === 2">
           <i class="el-icon-circle-check "/>
           <span class="text left-5">{{fileName}}文件上传成功，您已上传{{number}}个有效手机号</span>
       </section>
       <section class="info_con icon-error" v-if="status === 3">
           <i class="el-icon-error "/>
           <span class="text left-5">{{errorMsg}}</span>
       </section>
       <section class="updata_con">
           <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :multiple="false"
                :with-credentials="true"
                :show-file-list="false"
                :on-success="uploadSucessed"
                :on-progress="uploadProgressing"
                :on-error="uploadFailed"
            >
               <el-button>选择文件并上传</el-button>
           </el-upload>
           <span class="download" @click="downloadCsv" >下载xlsx模板</span>
       </section>
   </section>
</template>
<script>
import { Message } from 'element-ui'
import { download } from '../../../plugins/helper'
import serviceConfig from '../../../service/config'
import { getSignWithts } from '../../../service/sign'
export default {
  name: 'BatchUpdate',
  componentName: 'BatchUpdate',
  data () {
    return {
      key: '',
      number: '',
      fileName: '',
      status: 0,
      errorMsg: '文件上传失败，请重新上传',
      downloadUrl: '/eos/coupon/sendCoupon/downloadPhoneTemplate',
      uploadUrl: serviceConfig.baseURL + '/eos/coupon/sendCoupon/uploadFile'
    }
  },
  methods: {
    uploadSucessed: function (response, file) {
      console.log(response)

      if (response) {
        if (response.status === 0) {
          this.status = 2
          this.key = response.data && response.data.key
          this.number = response.data && response.data.number
          this.fileName = file.name
          this.$emit('listenkeyChange', response.data)
        } else {
          this.status = 3
          this.key = ''
          this.number = ''
          this.fileName = ''
          this.errorMsg = response.message
        }
      }
    },
    uploadProgressing: function () {
      if (this.status !== 1) {
        this.status = 1
      }
    },
    uploadFailed: function () {
      return Message.error('文件上传失败，请稍后再试')
    },
    downloadCsv: function () {
      console.log(this.downloadUrl)
      try {
        download(this.downloadUrl)
      } catch (e) {
        Message.error('手机号模版下载失败')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
 @-moz-keyframes loading-rotate {
     100%{
         transform: rotate(1turn)
     }
 }
 @-webkit-keyframes loading-rotate {
     100%{
         transform: rotate(1turn)
     }
 }
 @-o-keyframes loading-rotate {
     100%{
         transform: rotate(1turn)
     }
 }
 @keyframes loading-rotate {
     100%{
         transform: rotate(1turn)
     }
 }
 @-moz-keyframes loading-dash{
    0% {
        stroke-dasharray: 1,200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -40px;
    }
    100% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -120px;
    }
 }
 @-webkit-keyframes loading-dash{
    0% {
        stroke-dasharray: 1,200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -40px;
    }
    100% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -120px;
    }
 }
 @-o-keyframes loading-dash{
    0% {
        stroke-dasharray: 1,200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -40px;
    }
    100% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -120px;
    }
 }
 @keyframes loading-dash{
    0% {
        stroke-dasharray: 1,200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -40px;
    }
    100% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -120px;
    }
 }
.update_container{
    padding: 20px
    background: #F3F4F5
    .circular{
        height: 16px
        width: 16px
        vertical-align: middle
        animation: loading-rotate 2s linear infinite
        .path{
            animation: loading-dash 1.5s ease-in-out infinite
            stroke-dasharray: 90,150
            stroke-dashoffset: 0
            stroke-width: 2
            stroke: #409eff
            stroke-linecap: round
        }
    }
    .updata_con{
        padding:10px 0 12px 0
        position: relative
        .download{
            color: #3468FF
            font-family: PingFangSC-Medium, sans-serif
            font-size: 14px
            position: absolute
            top: 18px
            left: 153px
            cursor: pointer
            text-decoration none
        }
        .el-button--default{
            padding 10px 20px
            background none
            color #3468ff
        }
        .el-button--default:hover,.el-button--default:focus{
            background #EAEFFF
            border-color  #5f88ff
        }
    }
    .info_con{
        .text{
            font-family: PingFangSC-Regular
            font-size: 12px
            color: #666
            letter-spacing: 0
            line-height: 20px
        }
        .left-5{
            display: inline-block
            margin-left: 5px
        }
        .right-5{
            display: inline-block
            margin-right: 5px
        }
        .el-icon-circle-check{
            color: #4DBF84
            font-size: 16px
            vertical-align: middle
        }
        .el-icon-error{
            color #FF3939
            font-size: 16px
            vertical-align: middle
        }

    }
}
</style>
